const dutchDateFormatter = new Intl.DateTimeFormat('nl-NL', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

/**
 * Format an ISO publication date (e.g. "2026-06-03T00:00:00Z") to a readable
 * Dutch date like "3 juni 2026". Returns an empty string for missing/invalid input.
 */
export const formatPublicationDate = (isoDate: string | null | undefined): string => {
  if (!isoDate) {
    return ''
  }

  const date = new Date(isoDate)
  if (Number.isNaN(date.getTime())) {
    return ''
  }

  return dutchDateFormatter.format(date)
}
